import { httpGet } from "shared/api/apiHandler";
import urls from "shared/api/spaceStone/urls";
import { MenuItem } from "shared/models/spaceStone/menuItem";

export const getMenu = async (): Promise<MenuItem[]> => {
    const result = await httpGet<MenuItem[]>(window.APP_SETTINGS.spaceStoneApiBaseUri, urls.MENU.ROOT);
    return result.data;
};
